<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">توضیحات ارزش های حرفه‌ای شغل</h4>
    </div>
    <div class="card-body">
      <div class="card-body d-flex justify-content-around">
        <table>
          <table class="table">
            <thead>
            <tr>
              <th scope="col">ردیف</th>
              <th scope="col" class="nowrap">عنوان  ارزش</th>
              <th scope="col">توضیحات</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>1</td>
              <td class="nowrap">گرایش به نتیجه</td>
              <td>مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند، مشاغلی نتیجه محور هستند و کارکنان را قادر می‌سازد تا از بالاترین توانایی‌های خود در کار استفاده کنند و از این طریق به احساس کمال دست یابند. نیازهای مربوطه برای این ارزش کاری عبارت‌اند از استفاده از قابلیت‌ها و توانایی‌ها و دستیابی به نتیجه.</td>
            </tr>
            <tr>
              <td>2</td>
              <td class="nowrap">شرایط خوب کاری</td>
              <td>در مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند، امنیت شغلی و شرایط خوب کاری ارائه می‌گردد. الزامات برآورده سازی این ارزش کاری شامل فعالیت، جبران خدمت (درآمد)، استقلال، امنیت، تنوع و شرایط کاری است.</td>
            </tr>
            <tr>
              <td>3</td>
              <td class="nowrap">اعتبار شغلی</td>
              <td>مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند، امکان پیشرفت و پتانسیل دستیابی به سطوح مدیریت ارشد و رهبری سازمانی را در بر دارند و اغلب جزو مشاغل دارای اعتبار و پرستیژ بالا محسوب میگردند. نیازهای این ارزش کاری توان پیشرفت، اقتدار، به رسمیت شناخته شدن و اجتماعی بودن است.</td>
            </tr>
            <tr>
              <td>4</td>
              <td class="nowrap">ارتباطات گسترده</td>
              <td>ارتباطات گسترده	مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند، امکان ارائه خدمت به دیگران و کار با همکاران در محیطی غیررقابتی و دوستانه را برای فرد فراهم می‌کند. نیازهای مربوط به این ارزش کاری شامل همکاری با همکاران، ارزش‌های اخلاقی و ارائه خدمات اجتماعی است.</td>
            </tr>
            <tr>
              <td>5</td>
              <td class="nowrap">برخورداری از حمایت</td>
              <td>در مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند حمایت مدیریت سازمان از کارکنان مشهود است. نیازهای مربوط به این ارزش کاری شامل سیاست‌های شرکت/سازمان، نظارت بر روابط انسانی و نظارت بر امور فنی است.</td>
            </tr>
            <tr>
              <td>6</td>
              <td class="nowrap">استقلال در کار</td>
              <td>مشاغلی که این ارزش کاری را برای فرد برآورده می‌کنند به کارکنان اجازه می‌دهند مستقلاً به انجام کار و تصمیم‌گیری بپردازند. این ارزش کاری نیاز به خلاقیت، مسئولیت‌پذیری و استقلال دارد.</td>
            </tr>
            </tbody>
          </table>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {

}
</script>
